import React, { useState } from "react";
import { Clock, Users, Car, Shield, Star, ArrowRight } from "lucide-react";
import BookingModal from "../BookingModal";
import "./WhyChooseUs.css";

const STATS = [
  { value: "500+", label: "Happy Riders" },
  { value: "24/7", label: "Availability" },
  { value: "4.9", label: "Average Rating", icon: Star },
];

const FEATURES = [
  {
    id: 1,
    title: "On-Time Pickup & Drop",
    desc: "We value your time and ensure timely service every time.",
    icon: Clock,
  },
  {
    id: 2,
    title: "Professional Drivers",
    desc: "Our trained and polite drivers ensure a safe journey.",
    icon: Users,
  },
  {
    id: 3,
    title: "Clean & Comfortable Cars",
    desc: "Well-maintained vehicles for a smooth, relaxing travel.",
    icon: Car,
  },
  {
    id: 4,
    title: "Affordable Pricing",
    desc: "No hidden charges — simple and transparent pricing.",
    icon: Shield,
  },
];

export default function WhyChooseUs() {
  const [showPopup, setShowPopup] = useState(false);

  const handleBookNow = () => {
    setShowPopup(true);
    document.body.style.overflow = "hidden";
  };

  const closePopup = () => {
    setShowPopup(false);
    document.body.style.overflow = "auto";
  };

  return (
    <>
      <section className="why-choose">
        <div className="why-choose-split">
          {/* Left: dark stat panel */}
          <div className="why-panel">
            <div className="why-panel-eyebrow">
              <span className="why-panel-eyebrow-line" />
              Why Choose Us
            </div>
            <h2>
              Built on trust,
              <br />
              <span>mile after mile</span>
            </h2>
            <p>
              Safe rides, clean cars, trusted drivers — enjoy a smoother
              journey every time you book with us.
            </p>

            <div className="why-panel-stats">
              {STATS.map((stat) => (
                <div className="why-stat" key={stat.label}>
                  <span className="why-stat-value">
                    {stat.value}
                    {stat.icon && <stat.icon size={18} className="why-stat-icon" />}
                  </span>
                  <span className="why-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: feature rows */}
          <div className="why-features">
            {FEATURES.map((feature, index) => (
              <div className="why-feature-row" key={feature.id}>
                <span className="why-feature-index">0{index + 1}</span>
                <div className="why-feature-icon">
                  <feature.icon size={22} strokeWidth={2} />
                </div>
                <div className="why-feature-text">
                  <h3>{feature.title}</h3>
                  <p>{feature.desc}</p>
                </div>
              </div>
            ))}

            <button className="why-cta" onClick={handleBookNow}>
              <span>Book Your Ride Now</span>
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </section>

      <BookingModal isOpen={showPopup} onClose={closePopup} />
    </>
  );
}